import { useCallback } from 'react';

import { IFilterValues } from '@evinced-private/ui-common';

import { IFilterOptions } from 'src/common/helpers/DataFilterHelper';
import { flattenObject } from 'src/common/helpers/ObjectsHelper';
import { WEB_SDK_TEST_TABLE_ID } from 'src/common/pages/dashboards-container/dashboard_consts';
import { useTableState } from 'src/common/providers/dashboard/TableStateProvider';

import { IExtendedFilterOptions, V2Filters } from '../../../types/filter-section-v2';

interface UseFilterApplyHandlerV1Params {
	filterOptionsType: 'v1';
}

interface UseFilterApplyHandlerV2Params {
	filterOptionsType: 'v2';
	onFilterChange?: (filters: V2Filters) => void;
}

type UseFilterApplyHandlerParams = UseFilterApplyHandlerV1Params | UseFilterApplyHandlerV2Params;

export const useFilterApplyHandler = (
	params: UseFilterApplyHandlerParams
): { handleApply: (appliedFilters: IFilterValues) => void } => {
	const { onFilterChange: onTableFilterChange } = useTableState();

	const { filterOptionsType } = params;
	const v2OnFilterChange = filterOptionsType === 'v2' ? params.onFilterChange : undefined;

	const handleApply = useCallback(
		(appliedFilters: IFilterValues): void => {
			if (filterOptionsType === 'v1') {
				// V1: Always use table state handler
				const flatFilters = flattenObject<IFilterOptions>(appliedFilters);
				onTableFilterChange(WEB_SDK_TEST_TABLE_ID, flatFilters);
			} else {
				// V2: Use custom handler if provided, otherwise use table state handler
				const flatFilters = flattenObject<IExtendedFilterOptions>(appliedFilters);
				if (v2OnFilterChange) {
					v2OnFilterChange(flatFilters as V2Filters);
				} else {
					onTableFilterChange(WEB_SDK_TEST_TABLE_ID, flatFilters);
				}
			}
		},
		[filterOptionsType, v2OnFilterChange, onTableFilterChange]
	);

	return { handleApply };
};
